import { HERMES_URL } from "resources/constants";
import authClient from "lib/axios/clients";

export const getCompanies = () => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/companies`
  };

  return authClient.request(config);
};

export const getCompany = companyId => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/companies/${companyId}`
  };

  return authClient.request(config);
};

export const createCompany = company => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/companies`,
    data: company
  };

  return authClient.request(config);
};

export const deleteCompany = companyId => {
  const config = {
    method: "DELETE",
    url: `${HERMES_URL}/companies/${companyId}`
  };

  return authClient.request(config);
};
